export function mapProvisionError(e: unknown): Error {
  const code = typeof e === 'object' && e !== null && 'code' in e ? String((e as { code: string }).code) : '';
  if (code === 'auth/email-already-in-use') return new Error('Email already in use');
  if (code === 'auth/invalid-email') return new Error('Invalid email');
  if (code === 'auth/weak-password' || code === 'auth/invalid-password') {
    return new Error('Password must be at least 6 characters');
  }
  if (code === 'permission-denied') return new Error('Insufficient permissions');
  return e instanceof Error ? e : new Error('Failed to create user');
}
